@if (src) {
  <div>
    @if (!autoResize) {
      <iframe
        class="iframe"
        [src]="safeSource"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        id="iframeCompNoReisze"
      ></iframe>
    }
    @if (autoResize) {
      <iframe
        class="iframe"
        [src]="safeSource"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        id="iframeCompReisze"
        appIFrameResizer
        scrolling="no"
      ></iframe>
    }
  </div>
}

